import { DateTime } from 'luxon'

import { DEFAULT_WEEK_START_DAY } from '@/utils/time'

export default function getNextWeeks(
  count: number,
  weekStartDay = DEFAULT_WEEK_START_DAY
): { weekNumber: number; weekStartDate: DateTime }[] {
  const today = DateTime.local()
  const thisWeekStart = today.set({ weekday: weekStartDay }).startOf('day')
  const nextWeekStart = thisWeekStart.plus({ weeks: 1 })

  return Array.from({ length: count }, (_, i) => {
    const weekStartDate = nextWeekStart.plus({ weeks: i })
    return { weekNumber: weekStartDate.weekNumber, weekStartDate }
  })
}
